import { apiBackofficeReportsMs } from "@/services/api-backoffice-reports-ms";
import { GetBookingsProps } from "./get-bookings.types";

export const GetBookingsApi = async ({
  types,
  limit,
  offset,
  others,
  page,
}: GetBookingsProps) => {
  const searchParams = new URLSearchParams();

  types.forEach((type) => searchParams.append("types[]", `${type}`));
  limit && searchParams.append("limit", `${limit}`);
  offset && searchParams.append("offset", `${offset}`);
  page && searchParams.append("page", `${page}`);
  searchParams.append("appType", `3`);

  Object.entries(others).forEach(([key, value]) => {
    if (key !== "offset") {
      if (Array.isArray(value)) {
        value.forEach((item) => searchParams.append(`${key}[]`, `${item}`));
      } else {
        searchParams.append(`${key}`, `${value}`);
      }
    }
  });

  const { data } = await apiBackofficeReportsMs.get(
    `/bookings?${searchParams.toString()}`,
  );

  return data;
};
